/*
  Raffle Contest JavaScript
  Handles front-end interactions.
*/


document.addEventListener("DOMContentLoaded", () => {

  const form = document.querySelector(".raffle-entry-form");
  const success = document.querySelector(".raffle-success");
  const share = document.querySelector(".raffle-share");
  const button = document.querySelector(".raffle-submit-button");

  const copyButton = document.querySelector(".raffle-copy-link");
  const shareButton = document.querySelector(".raffle-native-share");
  const feedback = document.querySelector(".raffle-share-feedback");


  const workerURL =
    "https://raffle-klaviyo-worker.ops-f7e.workers.dev/";


  if (!form || !success || !button) {
    return;
  }



  button.addEventListener("click", async () => {


    const inputs = form.querySelectorAll("input");


    let valid = true;


    inputs.forEach((input) => {

      if (!input.checkValidity()) {

        valid = false;

        input.reportValidity();

      }

    });


    if (!valid) {
      return;
    }



    button.disabled = true;

    button.textContent = "Submitting...";



    const formData = new FormData(form);



    const raffleData = {

      first_name: formData.get("first_name"),

      last_name: formData.get("last_name"),

      email: formData.get("email"),

      phone: formData.get("phone"),

      raffle_id: formData.get("raffle_id"),

      raffle_campaign: formData.get("raffle_campaign"),

      raffle_prize: formData.get("raffle_prize"),

      raffle_source: formData.get("raffle_source")

    };



    try {


      const response = await fetch(

        workerURL,

        {

          method: "POST",

          headers: {

            "Content-Type": "application/json"

          },

          body: JSON.stringify(raffleData)

        }

      );



      const result = await response.json();



      if (!result.success) {

        throw new Error(
          "Raffle submission failed"
        );

      }



      form.hidden = true;

      success.hidden = false;



      if (share) {

        share.hidden = false;

      }



    } catch (error) {


      console.error(
        "Raffle submission error:",
        error
      );


      alert(
        "There was an issue submitting your entry. Please try again."
      );


      button.disabled = false;

      button.textContent =
        "Enter Giveaway";


    }


  });



  if (copyButton) {


    copyButton.addEventListener("click", async () => {


      await navigator.clipboard.writeText(

        window.location.href

      );



      if (feedback) {

        feedback.hidden = false;


        setTimeout(() => {

          feedback.hidden = true;

        }, 2000);

      }


    });


  }



  if (shareButton) {


    shareButton.addEventListener("click", async () => {


      if (navigator.share) {


        await navigator.share({

          title: document.title,

          text: "Check out this giveaway!",

          url: window.location.href

        });


      } else {


        await navigator.clipboard.writeText(

          window.location.href

        );


        if (feedback) {

          feedback.hidden = false;

        }


      }


    });


  }


});